<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="community-carousel">
      <ImageCarousel :theme="themeColor" :cta-container-direction="linkPosition" items-alignments="odd">
        <template #title>
          <heading
            v-if="isEditMode || title"
            class="title"
            desktop-size="size-5"
            mobile-size="size-5"
            :textField="fields.title"
            :tagField="fields.headingSize"
            default-tag="h2"
          />
          <!-- Bit of a hack but otherwise it disables all the named slots
          if we don't return anything -->
          <div v-else />
        </template>
        <template #cta>
          <sc-link v-if="isEditMode" class="sc-link" :field="fields.link"/>
          <sh-button
            v-if="!isEditMode && linkHref"
            :naked="true"
            :[btnLinkKey]="linkHref"
            :target="linkTarget"
            :aria-label="linkHiddenText || linkText"
          >
            {{ linkText }}
          </sh-button>
        </template>
        <template v-if="!isEditMode" v-for="tile in tiles">
          <component :key="tile.id" :is="tile.value" />
        </template>
      </ImageCarousel>
      <sc-placeholder
        v-if="isEditMode"
        class="carousel-editor"
        :rendering="rendering"
        name="digital-house-community-container"
      />
    </div>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text, Link, Placeholder } from '@sitecore-jss/sitecore-jss-vue'
import { ImageCarousel } from '@sohohouse/design-system'

import { getButtonType } from '~/helpers/get-button-type'
import { arrayUID } from '~/helpers/unique-id'
import mapFields from '~/helpers/map-fields'

import ScRender from '../sc-render'
import Heading from '../heading'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'CommunityCarousel',

  components: {
    ScText: Text,
    ScLink: Link,
    ScPlaceholder: Placeholder,
    ScRender,
    Heading,
    ImageCarousel
  },

  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  },

  withPlaceholder () {
    return {
      placeholders: [
        {
          placeholder: 'digital-house-community-container',
          computedPropName: 'tilesPlaceholder'
        }
      ]
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['themeColor']),
    ...mapFields({
      title: 'title.value',
      linkHref: 'link.value.href',
      linkText: 'link.value.text',
      linkTarget: 'link.value.target',
      linkHiddenText: 'link.value.data-hidden-text',
      linkPosition: 'linkPosition.value'
    }),
    tiles () {
      return arrayUID(this.tilesPlaceholder)
    },
    btnLinkKey () {
      return getButtonType(this.linkHref)
    }
  }
}
</script>

<style lang="scss" scoped>

.community-carousel {
  max-width: 100%;
  margin: $space-090 0;

  @include tablet() {
    margin: $space-110 0;
  }
}

.carousel-editor {
  width: 100%;
  display: flex;
  overflow-x: scroll;
  // to avoid extra carousel spaces in EE
  margin: -$space-120 $space-050 0;
}

</style>
